import draw from "./el-drawer"
import drag from "./el-drag-dialog"
import adaptive from "./el-adaptive"
import tadaptive from "./el-table-adaptive"
import fullscreen from "./el-dialog-fullscreen"
import scrollbarHeight from "./el-scrollbar-maxHeight"
import fileDrag from "./el-drag-file"

const directives = [
    draw,
    drag,
    adaptive,
    tadaptive,
    fullscreen,
    scrollbarHeight,
    fileDrag
]

export default directives